"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTournamentPrizes = void 0;
var react_1 = require("react");
var tournament_api_1 = require("@l2p/tournament-api");
var currencies_1 = require("../currencies");
var next_intl_1 = require("next-intl");
var useTournamentPrizes = function (tournament) {
    var _a;
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var t = (0, next_intl_1.useTranslations)('translation');
    return (0, react_1.useMemo)(function () {
        var _a;
        var allPrizes = {
            amount: 0,
            fs: 0,
            exp: 0,
            points: 0,
        };
        var result = '';
        (_a = tournament.baseTournament) === null || _a === void 0 ? void 0 : _a.rewards.forEach(function (reward) {
            var _a;
            if (reward.type === tournament_api_1.TournamentRewardType.Balance) {
                var cash = (_a = reward === null || reward === void 0 ? void 0 : reward.amount) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.currency === currentCurrency; });
                if (cash)
                    allPrizes.amount += cash.amount;
            }
            if (reward.type === tournament_api_1.TournamentRewardType.FreeRounds && reward.value)
                allPrizes.fs += reward.value;
            if (reward.type === tournament_api_1.TournamentRewardType.LoyalityExp)
                allPrizes.exp += reward.value || 0;
            if (reward.type === tournament_api_1.TournamentRewardType.LoyalityPoints)
                allPrizes.points += reward.value || 0;
        });
        if (allPrizes.amount > 0)
            result += "".concat(allPrizes === null || allPrizes === void 0 ? void 0 : allPrizes.amount, " ").concat(currentCurrency);
        if (allPrizes.fs > 0) {
            if (result !== '')
                result += " + ".concat(allPrizes.fs, " ").concat(t('fs'));
            else
                result += "".concat(allPrizes.fs, " ").concat(t('fs'));
        }
        if (allPrizes.exp > 0) {
            if (result !== '')
                result += " + ".concat(allPrizes.exp, " ").concat(t('exp'));
            else
                result += "".concat(allPrizes.exp, " ").concat(t('exp'));
        }
        if (allPrizes.points > 0) {
            if (result !== '')
                result += " + ".concat(allPrizes.points, " ").concat(t('points'));
            else
                result += "".concat(allPrizes.points, " ").concat(t('points'));
        }
        return result;
    }, [currentCurrency, (_a = tournament === null || tournament === void 0 ? void 0 : tournament.baseTournament) === null || _a === void 0 ? void 0 : _a.rewards, t]);
};
exports.useTournamentPrizes = useTournamentPrizes;
